// Sisterhood+ feature accent micro-tokens — mirrors Brotherhood's tinted feature
// system, re-toned warm & feminine (sage / plum / clay / gold / rose).
export const ACCENTS = {
  learn:    { bg: "#ECF3EE", fg: "#3D6B52", ring: "#3D6B52" },
  coach:    { bg: "#F3EEF4", fg: "#7B4C74", ring: "#7B4C74" },
  journal:  { bg: "#F7EDEA", fg: "#B06B62", ring: "#B06B62" },
  wellness: { bg: "#F8F0DF", fg: "#9A7526", ring: "#C89B55" },
  saved:    { bg: "#F1ECF2", fg: "#6B4E76", ring: "#6B4E76" },
  upgrade:  { bg: "#F8F0DF", fg: "#9A7526", ring: "#C89B55" },
  settings: { bg: "#EFEBE6", fg: "#59535B", ring: "#59535B" },
};
